// @flow
import React, { useState } from 'react'
import styles from './styles.css'
import type { DigitalFile as DigitalFileType } from 'lib/digital_file/model'

type Props = {
  file: DigitalFileType,
  onCancel: () => void,
  onConfirm: (name: string) => mixed,
}

const RenameDialog = ({ file, onCancel, onConfirm }: Props) => {
  const [name, setName] = useState(file.name)
  const [submitting, setSubmitting] = useState(false)

  const canSave = name.trim().length > 0 && !submitting

  const submit = async () => {
    if (!canSave) return
    setSubmitting(true)
    try {
      await onConfirm(name.trim())
    } catch (_err) {
      setSubmitting(false)
    }
  }

  return (
    <div className={styles.moveOverlay} role="dialog" aria-modal="true">
      <div className={styles.moveBackdrop} onClick={onCancel} />
      <div className={styles.moveCard}>
        <div className={styles.moveHeader}>
          <div className={styles.moveTitle}>Rename file</div>
        </div>
        <div className={styles.moveBody}>
          <div className={styles.moveBodyLabel}>File name</div>
          <input
            type="text"
            className={styles.renameInput}
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </div>
        <div className={styles.moveFooter}>
          <div className={styles.moveFooterLeft} />
          <div className={styles.moveFooterRight}>
            <button
              type="button"
              className={styles.moveCancel}
              onClick={onCancel}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="button"
              className={styles.moveConfirm}
              onClick={submit}
              disabled={!canSave}
            >
              {submitting ? 'Saving…' : 'Save'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RenameDialog
